module.exports = __webpack_public_path__ + "static/008505-8c7d88ad9e67ec61d1d02ffbceaefa8a.jpg";